import { render, staticRenderFns } from "./SuperiorSpirit.vue?vue&type=template&id=1f343d49&scoped=true"
import script from "./SuperiorSpirit.vue?vue&type=script&lang=js"
export * from "./SuperiorSpirit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f343d49",
  null
  
)

export default component.exports